import UsersTable from "features/affiliation/Users/UsersTable";
import CardsAndTableLayout from "features/affiliation/common/CardsAndTableLayout";
import {
  AffiliationTabs,
  UsersStatisticsTypes,
} from "features/affiliation/common/types";
import React from "react";
import useReferredUsers from "features/affiliation/common/hooks/useReferredUsers";
import StatisticsRow from "features/affiliation/common/StatisticsRow";
import ReferredUsersBarChart from "features/affiliation/common/Charts/ReferredUsersBarChart";

interface UserProps {
  tab: AffiliationTabs.REFERRED_USERS | AffiliationTabs.EXISTING_USERS;
}

const Users = ({ tab }: UserProps) => {
  const {
    referralHistoryQuery,
    users,
    statistics,
    tableTitle,
    getStatisticTotalValue,
    getStatisticLastMonthValue,
  } = useReferredUsers(tab);
  const isReferredUsersTab = tab === AffiliationTabs.REFERRED_USERS;

  const usersStatistics = (
    <StatisticsRow<UsersStatisticsTypes>
      statisticsTitles={statistics}
      getStatisticValue={getStatisticTotalValue}
      getLastMonthChangeValue={getStatisticLastMonthValue}
    />
  );

  const graph = isReferredUsersTab ? (
    <ReferredUsersBarChart hideSeeAllButton={true} />
  ) : undefined;

  const usersTable = (
    <UsersTable
      tab={tab}
      referredUsers={users}
      loading={referralHistoryQuery.isLoading}
    />
  );

  return (
    <CardsAndTableLayout
      loading={referralHistoryQuery.isLoading}
      table={usersTable}
      tableTitle={tableTitle}
      statistics={usersStatistics}
      graph={graph}
    />
  );
};

export default Users;
